import request from '@/router/axios'
import env from '@/config/env'
const baseUrl = env.ferryUrl + '/operation-report/'
// 获取营收达成情况
export const getPieData = () => {
  return request({
    url: baseUrl + 'visual-revenue-target',
    method: 'GET'
  })
}
// 获取营收目标详情
export const getRevenueDetail = (params) => {
  return request({
    url: baseUrl + 'visual-revenue-target-detail',
    method: 'GET',
    params
  })
}
// 获取用户达成情况
export const getPieUserData = () => {
  return request({
    url: baseUrl + 'visual-user-target',
    method: 'GET'
  })
}
// 获取用户目标详情
export const getUserDetail = (params) => {
  return request({
    url: baseUrl + 'visual-user-target-detail',
    method: 'GET',
    params
  })
}
// 获取营收情况
export const getRevenueSummary = (data) => {
  return request({
    url: baseUrl + 'visual-revenue-situation',
    method: 'POST',
    data
  })
}
// 获取营收情况明细
export const getRevenueSummaryDetail = (data) => {
  return request({
    url: baseUrl + 'visual-revenue-situation-detail',
    method: 'POST',
    data
  })
}
// 获取可视化营收环比-同比
export const getRevenueRate = (data) => {
  return request({
    url: baseUrl + 'visual-revenue-dod',
    method: 'POST',
    data
  })
}
// 获取上座率退票率
export const getSeatRefundRate = (data) => {
  return request({
    url: baseUrl + 'visual-seat-refund-rate',
    method: 'POST',
    data
  })
}
// 获取服务人数&订单数
export const getPassengerOrder = (data) => {
  return request({
    url: baseUrl + 'visual-passenger-order-num',
    method: 'POST',
    data
  })
}

// 获取营收统计
export const getRevenueCount = () => {
  return request({
    url: baseUrl + 'visual-this-month-revenue',
    method: 'GET'
  })
}
// 获取用户统计
export const getUserCount = () => {
  return request({
    url: baseUrl + 'visual-passenger-order-kanban',
    method: 'GET'
  })
}
// 获取新增用户&环比
export const getNewUser = (data) => {
  return request({
    url: env.ferryUrl + '/user/newUserVisual',
    method: 'POST',
    data
  })
}
// 获取云推官
export const getPromoter = (data) => {
  return request({
    url: env.ferryUrl + '/user/agentV2Visual',
    method: 'POST',
    data
  })
}
// 获取云推官小看板统计
export const getPromoterCount = (data) => {
  return request({
    url: env.ferryUrl + '/user/agentV2Count',
    method: 'POST',
    data
  })
}
